import React, { useState } from "react";

import { Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  CustomerSalesOnOrderSearchCriteria,
  CustomerSearchCriteria,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  PopupCustomerSalesDetailPrintRequest,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  DatePickerComponent_adv,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
class CustomerOnOrder extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Customer OnOrder Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new CustomerSalesOnOrderSearchCriteria(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMessage: [],
      success_list: [],
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowSalesModule: false,
      moduleForPopup: [],
      isShowColorLookup: false,
      isCollapsible_open: true,
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowCriteriaView: true,
      locations: [],
      showAutoCompleteLocationList: true,
      locationPageListForAutoCompleteList: new Array(),
      isDisableFields: false,
      is3PL: false,
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.initLookupHandlers();
    if (
      this.props.customerCode !== "" &&
      this.props.customerCode !== undefined
    ) {
      let criteria = this.state.criteria;
      criteria.customerCode = this.props.customerCode;
      this.setState({
        criteria: criteria,
        isShowCriteriaView: false,
        isShowResetButton: false,
        isShowExecuteButton: false,
        isShowClearCriteriaButton: false,
      });
      this.loadPage(1);
    }
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.locations.push(attr);
      });
    }
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
    let locationLookupHandler = new GenericAttributeLookupHandler(
      this.state.locations,
      "Location",
    );
    this.setState({ locationLookupHandler: locationLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.criteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        criteria: criteria,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.locations.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        criteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.locations;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color",
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack,
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack,
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(e.target.value);

    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == criteria.fabricStyleCode &&
        sku.colorCode == searchString
      )
        skuBean = sku;
    });
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == criteria.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;

      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack,
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadCustomerOnOrderInquiryList(criteria);
  };
  loadCustomerOnOrderInquiryList = (criteria) => {
    if (SecurityAccessManager.CustomerOnOrderInquiry_IsAccessible()) {
      CustomerService.getCustomerSalesOnOrderDetails(
        criteria,
        this.loadCustomerOnOrderQtyPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadCustomerOnOrderQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      let customerQtyDataList = [];
      if (!isEmptyArray(response.data.orderDetailsResult.onOrderInfoDetails)) {
        customerQtyDataList =
          response.data.orderDetailsResult.onOrderInfoDetails;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryDataList: customerQtyDataList,
        isShowClearCriteriaButton: false,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        isShowColorLookup: false,
      });
      this.disable();
    } else {
      let errMsg = "No Data Found";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }

    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateCustomerOnOrderReport = (reportType) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new PopupCustomerSalesDetailPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CustomerOnOrderInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateCustomerSalesOnOrderDetailsPrintReport(
          listRequest,
          this.generateCustomerOnOrderResponse,
          this.errorCallBack,
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CustomerOnOrderInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateCustomerSalesOnOrderDetailsPrintReport(
          listRequest,
          this.generateCustomerOnOrderExcelResponse,
          this.errorCallBack,
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
    generateCustomerOnOrderResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
         window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateCustomerOnOrderExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      //  window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new CustomerSalesOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      isDisableFields: false,
      isShowClearCriteriaButton: true,
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new CustomerSalesOnOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowColorLookup: false,
      isCollapsible_open: true,
      isDisableFields: false,
      isShowClearCriteriaButton: true,
    });
    this.hideAlertCallBack();
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  generatePDF = () => {
    this.generateCustomerOnOrderReport(1);
  };
  generateExcel = () => {
    this.generateCustomerOnOrderReport(2);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowSalesModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewCustomerModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item#" : "FabricStyle#",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.viewFabricModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnOrder Quantity", "onOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Cust.P.O#", "customerPONumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("S.O#", "salesOrderNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewSalesModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("S.O Date", "salesOrderDate", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("S.O StartDate", "salesOrderStartDate", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Latest ShipDate", "revisedLatestShipDate", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("RevisedShipDate", "revisedLatestShipDate", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson", "salesPersonCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CSR", "customerSalesRepresentativeCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Width", "widthCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item Name" : "FabricStyle Name",
          "fabricStyleShortName",
          true,
        )
        .setStyleDetails("left", "6", "", "wt-6", "wt-6"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Extension", "lineTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Remarks", "remarks", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    return columns;
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
          onModuleExit={this.onModuleExit}
        />
        {this.state.isShowCriteriaView ? (
          <CriteriaView
            {...this.state}
            loadPage={this.loadPage}
            onChange={this.onChange}
            fabricLookupHandler={this.state.fabricLookupHandler}
            customerLookupHandler={this.state.customerLookupHandler}
            fabricCodeOnChange={this.fabricCodeOnChange}
            customerCodeOnChange={this.customerCodeOnChange}
            showHideSecondHeader={this.showHideSecondHeader}
            customerCodeRef={this.customerCodeRef}
            customerCodeEnterKeyEventHandler={
              this.customerCodeEnterKeyEventHandler
            }
            displayAutoCompleteList={this.displayAutoCompleteList}
            fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
            displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
            fabricColourEnterKeyEventHandler={
              this.fabricColourEnterKeyEventHandler
            }
            displayAutoCompleteFabricColorList={
              this.displayAutoCompleteFabricColorList
            }
            onFabricColourCodeChange={this.onFabricColourCodeChange}
            locationCodeOnChange={this.locationCodeOnChange}
            locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
            displayAutoCompleteLocationList={
              this.displayAutoCompleteLocationList
            }
          />
        ) : null}

        {this.state.isInquiryDatasFound && (
          <div className="mt-3">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              enableVritualizer={true}
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  let customerLookupHandler = props.customerLookupHandler;
  let customerCodeRef = React.createRef();
  let isDisableFields = props.isDisableFields;
  const showHideSecondHeader = (e) => {
    if (e.detail === 1) props.showHideSecondHeader();
  };
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  let isShowColorLookup = props.isShowColorLookup;
  let colorLookupHandler = props.colorLookupHandler;
  let locationLookupHandler = props.locationLookupHandler;
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const locationEnterKeyEventHandler = (e) => {
    props.locationEnterKeyEventHandler(e);
  };
  const displayAutoCompleteLocationList = () => {
    props.displayAutoCompleteLocationList();
  };
  const locationCodeOnChange = (e) => {
    props.locationCodeOnChange(e);
  };
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            placeholder="Customer"
            onChange={customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={true}
            lookupHandler={customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>FabricStyle</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleCode"
            placeholder="Item"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={true}
            lookupHandler={fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={isDisableFields}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onFabricColourCodeChange}
              name="colorCode"
              placeholder="color"
              value={criteria.colorCode}
              lookupRequired={isShowColorLookup}
              lookupHandler={colorLookupHandler}
              enterKeyEventHandler={fabricColourEnterKeyEventHandler}
              autoCompleteListData={
                props.fabricColourPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteFabricColorList}
              showAutoCompleteList={props.showAutoCompleteFabricColorList}
              disabled={!isShowColorLookup}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>OrderStartDate From</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="fromOrderStartDate"
              value={criteria.fromOrderStartDate}
              onChange={onChange}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            <FormLabel>OrderStartDate To</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="toOrderStartDate"
              onChange={onChange}
              value={criteria.toOrderStartDate}
              disabled={isDisableFields}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>OrderStopDate From</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="fromOrderStopDate"
              value={criteria.fromOrderStopDate}
              onChange={onChange}
              disabled={isDisableFields}
            />
          </Col>
        </Row>
      )}
      {props.isCollapsible_open && (
        <Row>
          <Col sm="1">
            <FormLabel>OrderStopDate To</FormLabel>
          </Col>
          <Col sm="2">
            <DatePickerComponent_adv
              name="toOrderStopDate"
              onChange={onChange}
              value={criteria.toOrderStopDate}
              disabled={isDisableFields}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
function CustomerOnOrderInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CustomerOnOrder {...props} name="" /> <br />
    </div>
  );
}

export default CustomerOnOrderInquiry;
